export const QA_NAME_LIKE_ACTION = 'like'

export const QA_NAME_COMMENTS_ACTION = 'comments'

export const QA_NAME_AUTOMATE_ACTION = 'automate'

export const QA_NAME_VIEWS_ACTION = 'views'
